import { OrderBook } from '../../types/orderBook';

const MAX_RECONNECT_ATTEMPTS = 5;
const RECONNECT_DELAY = 3000;

export const subscribeOrderBookSSE = (securityKey: string, depth: number, onData: (data: OrderBook) => void) => {
  let reconnectAttempts = 0;
  let eventSource: EventSource | null = null;

  const connect = () => {
    if (eventSource) {
      eventSource.close();
    }

    if (!securityKey) {
      console.error('securityKey не может быть пустым');
      return () => {};
    }

    const encodedSecurityKey = encodeURIComponent(securityKey.trim());
    let url = `/api/securities/orderbook/${encodedSecurityKey}`;

    if (depth !== 0) {
      url += `/${depth}`;
    }

    eventSource = new EventSource(url);

    const handleOrderBookMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);
        onData(data);
        reconnectAttempts = 0;
      } catch (e) {
        console.error('Ошибка парсинга данных стакана SSE:', e);
      }
    };

    eventSource.addEventListener('ORDER_BOOK_SECURITY_TYPE', handleOrderBookMessage);

    eventSource.onerror = (event) => {
      console.error('SSE Error:', event);

      if (eventSource) {
        eventSource.close();
        eventSource = null;
      }

      if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
        reconnectAttempts++;
        console.log(`Попытка переподключения ${reconnectAttempts} из ${MAX_RECONNECT_ATTEMPTS}`);
        setTimeout(connect, RECONNECT_DELAY);
      } else {
        console.error('Превышено максимальное количество попыток переподключения');
      }
    };

    return () => {
      if (eventSource) {
        eventSource.removeEventListener('ORDER_BOOK_SECURITY_TYPE', handleOrderBookMessage);
        eventSource.close();
        eventSource = null;
      }
    };
  };

  const cleanup = connect();

  return () => {
    cleanup();
  };
};
